import {extendTheme} from '@mui/joy/styles';

export const theme = extendTheme({
    fontFamily:{
        body: 'Rubik, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        display: 'Rubik, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        fallback: 'Rubik, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        code: 'Rubik, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'

        //body: 'Rubik, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
    },

    colorSchemes: {

        light: {
            palette: {
                background: {
                    surface: '#f1f1f1',
                },
                primary: {
                    // Credit:
                    // https://github.com/tailwindlabs/tailwindcss/blob/master/src/public/colors.js
                    50: '#f9f2fd',
                    100: '#f4e7fc',
                    200: '#ebcffb',
                    300: '#dba8f9',
                    400: '#c072f4',
                    500: '#aa48ec',
                    600: '#9927db',
                    700: '#8718be',
                    800: '#6c179d',
                    900: '#a100ff',
                    // Adjust the global variant tokens as you'd like.
                    // The tokens should be the same for all color schemes.
                    solidColor:'var(--joy-palette-neutral-50)',
                    solidBg: 'var(--joy-palette-primary-700)',
                    solidActiveBg: 'var(--joy-palette-primary-900)',
                    outlinedBorder: 'var(--joy-palette-primary-700)',
                    outlinedColor: 'var(--joy-palette-primary-700)',
                    outlinedActiveBg: 'var(--joy-palette-primary-900)',
                    softColor: 'var(--joy-palette-primary-500)',
                    softBg: 'var(--joy-palette-neutral-300)',
                    softActiveBg: 'var(--joy-palette-primary-900)',
                    plainColor: 'var(--joy-palette-primary-700)',
                    plainActiveBg: 'var(--joy-palette-primary-900)',
                },

            },
        },
        dark: {
            palette: {
                background: {
                    surface: '#101010',
                },
                primary: {
                    // Credit:
                    // https://github.com/tailwindlabs/tailwindcss/blob/master/src/public/colors.js
                    50: '#fbfdf2',
                    100: '#f7fce7',
                    200: '#f3fbcf',
                    300: '#eaf9a8',
                    400: '#d8f472',
                    500: '#ceec48',
                    600: '#b4db27',
                    700: '#9abe18',
                    800: '#7c9d17',
                    900: '#6c8318',
                    // Adjust the global variant tokens as you'd like.
                    // The tokens should be the same for all color schemes.
                    solidColor:'var(--joy-palette-neutral-900)',
                    solidBg: 'var(--joy-palette-primary-700)',
                    solidActiveBg: 'var(--joy-palette-primary-900)',
                    outlinedBorder: 'var(--joy-palette-primary-700)',
                    outlinedColor: 'var(--joy-palette-primary-700)',
                    outlinedActiveBg: 'var(--joy-palette-primary-900)',
                    softColor: 'var(--joy-palette-primary-500)',
                    softBg: 'var(--joy-palette-neutral-900)',
                    softActiveBg: 'var(--joy-palette-primary-900)',
                    plainColor: 'var(--joy-palette-primary-700)',
                    plainActiveBg: 'var(--joy-palette-primary-900)',
                },
            },

        },
    },
});

// Then, pass it to `<CssVarsProvider theme={theme}>`.
